// extracted by mini-css-extract-plugin
export default {"host":"styles_host__EfcAd","title":"styles_title__Ska64","termText":"styles_termText__ZuoJ4","terms":"styles_terms__42Obq"};